import { render, staticRenderFns } from "./aftersalebill.vue?vue&type=template&id=15fa7c59&"
import script from "./aftersalebill.vue?vue&type=script&lang=js&"
export * from "./aftersalebill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports